import React from 'react';
import { PropInfo, CodeExample, CardProps } from '@cimpress/react-components';
import CardCode from '!raw-loader!./card.tsx';
import CardDemo from './card';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const CardDocs = () => {
  const propInfos: PropInfo<CardProps>[] = [
    {
      name: 'children',
      type: 'node',
      default: '',
      description: 'The body of the card. Can be anything.',
    },
    {
      name: 'header',
      type: 'node',
      default: '',
      description:
        'The header of the card. Typically a title or an svg such as a CardHeader from Shapes. If not provided, no header will render.',
    },
    {
      name: 'isMinimal',
      type: 'boolean',
      default: '',
      description: 'Simplifies the look of the header. Defaults to false.',
    },
    {
      name: 'variant',
      type: 'string',
      default: 'default',
      description: (
        <div>
          The variant of card you are creating, providing one of the following values:
          <ul>
            <li>default</li>
            <li>layout</li>
            <li>minimal</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <ComponentDoc<CardProps> name="Card" propInfos={propInfos}>
      <CardDemo />
      <CodeExample code={CardCode} />
    </ComponentDoc>
  );
};

export default CardDocs;
